// Shared client-side mirror of backend's services/po_helpers.py::check_line_item_mismatch —
// gives PMs an immediate, advisory-only warning while filling in a delivery form.
const TYPE_CONFLICT_KEYWORDS = {
  session: ['conference', 'regional', 'in-person event', 'rio '],
  partner_conference: ['session', 'regional in-person', 'rio '],
  regional_in_person: ['conference', 'virtual session', '1:many'],
};

export function computeLineItemMismatchWarnings(lineItem, deliveryType, deliveryDateStr, invoiceAmount) {
  const warnings = [];
  if (!lineItem) return warnings;

  const liDate = lineItem.delivery_date ? new Date(lineItem.delivery_date) : null;
  const dDate = deliveryDateStr ? new Date(deliveryDateStr) : null;
  if (liDate && dDate && !isNaN(liDate) && !isNaN(dDate)) {
    const diffDays = Math.round(Math.abs(liDate - dDate) / 86400000);
    if (diffDays > 45) {
      warnings.push(
        `Selected line item's planned delivery date (${lineItem.delivery_date}) is ${diffDays} days away from this delivery's date (${deliveryDateStr}).`
      );
    }
  }

  const amount = parseFloat(lineItem.amount) || 0;
  const consumed = parseFloat(lineItem.consumed_amount) || 0;
  const invoice = parseFloat(invoiceAmount) || 0;
  const projectedConsumed = consumed + invoice; // this delivery hasn't saved yet, so add it live
  if (amount > 0 && projectedConsumed > amount + 0.01) {
    warnings.push(
      `This delivery's amount would bring the line item's total to $${projectedConsumed.toLocaleString()}, exceeding its planned amount ($${amount.toLocaleString()}).`
    );
  }

  const desc = (lineItem.description || '').toLowerCase();
  const conflicting = (TYPE_CONFLICT_KEYWORDS[deliveryType] || []).filter(kw => desc.includes(kw));
  if (conflicting.length > 0) {
    warnings.push(`Line item description mentions '${conflicting[0].trim()}' which may not match this delivery type.`);
  }

  return warnings;
}
